import { render } from "./LogsDetailQC.vue?vue&type=template&id=3c2a6028"
import script from "./LogsDetailQC.vue?vue&type=script&lang=js"
export * from "./LogsDetailQC.vue?vue&type=script&lang=js"

import "./LogsDetailQC.vue?vue&type=style&index=0&id=3c2a6028&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__